import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserAiConversations = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [
        ...userColumns,
        { field: 'conversationDatetime', name: 'Conversation Date ({tz} time zone)', dataType: 'datetime' },
        {
            field: 'topic',
            name: 'Topic',
            dataType: 'string',
            styles: { minWidth: '20rem' },
        },
        { field: 'messageCount', name: 'User Messages', dataType: 'numeric' },
        {
            field: 'sentimentScore',
            name: 'Sentiment Score (-1 to 1)',
            dataType: 'numeric',
        },
    ];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.conversationDatetime),
    //     { count: true }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Conversations',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart
                    data={chartData}
                    chartTitle="AI Conversations Over Time"
                />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows detailed information about individual AI
                    conversations between users and the AI assistant. Each row represents
                    a single conversation session.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Conversation Date">
                    When the conversation session took place.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Topic">
                    The main subject or theme discussed during the conversation,
                    automatically categorized.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="User Messages">
                    The number of messages the user sent during this specific
                    conversation.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Sentiment Score (-1 to 1)">
                    AI-analyzed sentiment of the conversation, ranging from -1 (negative)
                    to 1 (positive).
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserAiConversations;
